






























import Vue from 'vue';
import { mapGetters } from 'vuex';
import ExaminationBoardCard from '@/components/cards/ExaminationBoardCard.vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import Pagination from '@/components/Pagination.vue';
import Header from '@/components/Header.vue';
import Loading from '@/dex-shared/components/Loading.vue';
import ExaminationBoardModel from '@/dex-shared/models/ExaminationBoardModel';

export default Vue.extend({
  components: {
    ExaminationBoardCard,
    pxButton,
    Pagination,
    Header,
    Loading,
  },

  data() {
    return {
      currentPage: 0,
      loaded: true,
    };
  },

  computed: {
    ...mapGetters({
      allExaminationBoards: 'allExaminationBoards',
    }),

    examinationBoards() {
      return this.allExaminationBoards
        .concat()
        .sort((a: ExaminationBoardModel, b: ExaminationBoardModel) =>
          a.title.localeCompare(b.title),
        );
    },
  },

  created() {
    const page = parseInt(this.$route.params.page);
    if (page > 0) {
      this.currentPage = page - 1;
    } else {
      this.$router.replace(`/bancas`);
    }
    this.pullInfo();
  },

  methods: {
    pullInfo: async function() {
      this.loaded = false;
      try {
        await this.$store.dispatch('PULL_EXAMINATION_BOARDS', {
          currentPage: this.currentPage,
        });
      } catch (e) {
        alert(
          `Algo deu errado. Envie essas informações para os desenvolvedores: ${e}`,
        );
      }
      this.loaded = true;
    },

    changePage: async function(event: number) {
      this.currentPage = event;
      await this.pullInfo();
      this.$router.push(`/bancas/${this.currentPage + 1}`);
    },
  },
});
